import React, { Fragment, useState, useEffect } from "react";
import useOtherDocuments from "../Libs/useFetchOtherDoc";
import { useDeleteOtherDocs } from "../Libs/useDeleteOtherDoc";
import { CiFileOn } from "react-icons/ci";
import { RiDeleteBin6Line } from "react-icons/ri";
import Skeleton from "react-loading-skeleton";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "react-loading-skeleton/dist/skeleton.css";

const ViewOtherDocs = () => {
  const { data, isLoading, error } = useOtherDocuments();
  const deleteMutation = useDeleteOtherDocs();

  const [isDeleteConfirmationVisible, setDeleteConfirmationVisible] = useState(false);
  const [selectedDocumentToDelete, setSelectedDocumentToDelete] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteError, setDeleteError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [isLoadingPdf, setIsLoadingPdf] = useState(false);

  const toggleDeleteConfirmation = () => {
    setDeleteConfirmationVisible(!isDeleteConfirmationVisible);
  };

  const handleDocumentSelection = (document) => {
    setSelectedDocumentToDelete(document);
    toggleDeleteConfirmation();
  };

  const handleDelete = () => {
    if (selectedDocumentToDelete) {
      const documentToDelete = {
        otherDocuments: [
          {
            _id: selectedDocumentToDelete._id,
            name: selectedDocumentToDelete.name,
            fileUrl: selectedDocumentToDelete.fileUrl,
          },
        ],
      };
      setIsDeleting(true);
      deleteMutation.mutate(documentToDelete, {
        onSuccess: () => {
          console.log("Document deleted successfully!");
          setSelectedDocumentToDelete(null);
          toggleDeleteConfirmation();
        },
        onError: (error) => {
          console.error("Error deleting document:", error);
          setDeleteError(
            error.response?.data?.message ||
            "An error occurred while deleting the document."
          );
        },
        onSettled: () => {
          setIsDeleting(false);
        },
      });
    }
  };

    const handleViewPdf = (url) => {
      setIsLoadingPdf(true);
      setPdfUrl(url);
      setShowModal(true);
    };
  
    useEffect(() => {
      if (pdfUrl) {
        const timer = setTimeout(() => setIsLoadingPdf(false), 1000);
        return () => clearTimeout(timer);
      }
    }, [pdfUrl]);
  
    const closeModal = () => {
      setShowModal(false);
      setPdfUrl("");
    };

  const otherDocs = data?.data?.otherDocuments || [];

  return (
    <Fragment>
      {/* PDF Viewing Modal */}
      {showModal && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            {isLoadingPdf ? (
              <p>Loading document...</p>
            ) : (
              <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                <Viewer fileUrl={pdfUrl} />
              </Worker>
            )}
          </div>
          <button onClick={closeModal}>Close</button>
        </div>
      )}

      {/* Delete Confirmation Overlay */}
      {isDeleteConfirmationVisible && (
        <div className="delete-overlay">
          <div className="delete-overlay-content">
            <h2>Delete Confirmation</h2>
            <p>Are you sure you want to delete this document?</p>
            <div className="btn-group">
              <button onClick={toggleDeleteConfirmation}>No</button>
              <button onClick={handleDelete} disabled={isDeleting}>
                {isDeleting ? "Deleting..." : "Yes"}
              </button>
            </div>
            {deleteError && <p>Error: {deleteError}</p>}
          </div>
        </div>
      )}

      <div className="sta">
        {isLoading ? (
          <div className="sta-card">
            {[...Array(3)].map((_, index) => (
              <div className="cards" key={index}>
                <div className="in">
                  <Skeleton circle height={40} width={40} />
                  <div className="size">
                    <Skeleton height={20} width={100} />
                    <Skeleton height={16} width={200} />
                  </div>
                </div>
                <div className="mark">
                  <Skeleton height={30} width={60} />
                </div>
              </div>
            ))}
          </div>
        ) : error ? (
          <div>Error: {error.message}</div>
        ) : (
          otherDocs.length > 0 ? (
            <div className="sta-card">
              {otherDocs.map((document) => (
                <div className="cards" key={document._id}>
                  <div className="in">
                    <CiFileOn className="file" />
                    <div className="size">
                      <h4>{document.name}</h4>
                      <p>200 KB – 100% Uploaded</p>
                    </div>
                  </div>
                  <div className="mark">
                    <button onClick={() => handleDocumentSelection(document)}>
                      <RiDeleteBin6Line />
                    </button>
                    <button onClick={() => handleViewPdf(document.fileUrl)}>
                      View
                    </button>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div style={{fontFamily:"Montserrat", fontSize:"16px", fontWeight:"500", color:"#000000"}}>No other docs available</div>
          )
        )}
      </div>
    </Fragment>
  );
};

export default ViewOtherDocs;
  
  

